import { useQuery } from "@tanstack/react-query";
import { procurementPipelineApi } from "../api/procurementPipeline";

export const useFetchMaterialTrendStatistics = ({ quickFilters }: { quickFilters: any }) => {
    const { data, isFetching, isPending, isError, refetch } = useQuery({
        //     queryKey: ["material-request-trend-statistics" ,quickFilters.workstream, quickFilters.site, quickFilters.programme, quickFilters.region],
        //     queryFn: () =>{
        //    return  procurementPipelineApi.fetchMaterialTrendStatistics({
        //     workstream_id: quickFilters.workstream || null,
        //     site_id: quickFilters.site || null,
        //     programme_id: quickFilters.programme || null,
        //     region_id: quickFilters.region || null,
        //   });
        // }

        queryKey: ["material-request-trend-statistics"],
        queryFn: () => {
            return procurementPipelineApi.fetchMaterialTrendStatistics();
        }

    });

    return {
        trendData: data?.data?.trend_data || [],
        periodType: data?.data?.period_type,
        isPending,
        isFetching,
        isError,
        refetch
    };
};

export const useFetchResourceTrendStatistics = ({ quickFilters }: { quickFilters: any }) => {
    const { data, isFetching, isPending, isError, refetch } = useQuery({
        // queryKey: ["resource-request-trend-statistics", quickFilters.workstream, quickFilters.site, quickFilters.programme, quickFilters.region],
        // queryFn: () => procurementPipelineApi.fetchResourceTrendStatistics({
        //     workstream_id: quickFilters.workstream || null,
        //     site_id: quickFilters.site || null,
        //     programme_id: quickFilters.programme || null,
        //     region_id: quickFilters.region || null,
        // }),
        queryKey: ["resource-request-trend-statistics"],
        queryFn: () => procurementPipelineApi.fetchResourceTrendStatistics(),
    });

    return {
        trendData: data?.data?.trend_data || [],
        periodType: data?.data?.period_type,
        isPending,
        isFetching,
        isError,
        refetch
    };
};

// add new hooks for lead time statistics

export const useFetchMaterialLeadTimeStatistics = ({ quickFilters }: { quickFilters: any }) => {
    const { data, isFetching, isPending, isError, refetch } = useQuery({
        // queryKey: ["material-lead-time-statistics", quickFilters.workstream, quickFilters.site, quickFilters.programme, quickFilters.region],
        // queryFn: () => {
        //     return procurementPipelineApi.fetchMaterialLeadTimeStatistics({
        //         workstream_id: quickFilters.workstream || null,
        //         site_id: quickFilters.site || null,
        //         programme_id: quickFilters.programme || null,
        //         region_id: quickFilters.region || null,
        //     });
        // },

        queryKey: ["material-lead-time-statistics"],
        queryFn: () => {
            return procurementPipelineApi.fetchMaterialLeadTimeStatistics();
        },
    });

    // Transform API response to LeadTimeData format
    const transformedData = data?.data?.map((item: any) => ({
        type: item.material_type_display_text,
        days: Math.round(item.average_lead_time_days * 10) / 10,
    })) || [];

    return {
        leadTimeData: transformedData,
        isPending,
        isFetching,
        isError,
        refetch
    };
};
export const useFetchResourceLeadTimeStatistics = ({ quickFilters }: { quickFilters: any }) => {
    const { data, isFetching, isPending, isError, refetch } = useQuery({
        // queryKey: ["resource-lead-time-statistics", quickFilters.workstream, quickFilters.site, quickFilters.programme, quickFilters.region],
        // queryFn: () => {
        //     return procurementPipelineApi.fetchResourceLeadTimeStatistics({
        //         workstream_id: quickFilters.workstream || null,
        //         site_id: quickFilters.site || null,
        //         programme_id: quickFilters.programme || null,
        //         region_id: quickFilters.region || null,
        //     });
        // },

        queryKey: ["resource-lead-time-statistics"],
        queryFn: () => {
            return procurementPipelineApi.fetchResourceLeadTimeStatistics();
        },
    });

    // Transform API response to LeadTimeData format
    const transformedData = data?.data?.map((item: any) => ({
        type: item.resource_type_display_text,
        days: Math.round(Math.max(0, item.average_lead_time_days) * 10) / 10,
    })) || [];

    return {
        leadTimeData: transformedData,
        isPending,
        isFetching,
        isError,
        refetch
    };
};